module.exports = __webpack_public_path__ + "static/yogi-zen-mobile-f7e9da38cb8a93739974e9b07b7ac67d.png";